/* eslint-disable no-undef */
export const publicRoutes = [
  "signup",
  "login",
  "set-password",
  "forget-password",
];

export const exposedRoutePages = ["order", "finance"];

export const timesOptions = [
  { label: "12:00", value: "12:00" },
  { label: "12:30", value: "12:30" },
  { label: "1:00", value: "1:00" },
  { label: "1:30", value: "1:30" },
  { label: "2:00", value: "2:00" },
  { label: "2:30", value: "2:30" },
  { label: "3:00", value: "3:00" },
  { label: "3:30", value: "3:30" },
  { label: "4:00", value: "4:00" },
  { label: "4:30", value: "4:30" },
  { label: "5:00", value: "5:00" },
  { label: "5:30", value: "5:30" },
  { label: "6:00", value: "6:00" },
  { label: "6:30", value: "6:30" },
  { label: "7:00", value: "7:00" },
  { label: "7:30", value: "7:30" },
  { label: "8:00", value: "8:00" },
  { label: "8:30", value: "8:30" },
  { label: "9:00", value: "9:00" },
  { label: "9:30", value: "9:30" },
  { label: "10:00", value: "10:00" },
  { label: "10:30", value: "10:30" },
  { label: "11:00", value: "11:00" },
  { label: "11:30", value: "11:30" },
];

export const numberToAvailableDaysMapper = {
  6: "Saturday",
  7: "Sunday",
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
};

export const resumeType = "resume";
export const sampleOfWorkType = "sampleOfWork";
export const certificationType = "certification";
export const rateCardType = "rateCard";
export const portfolioType = "portfolio";
export const vmFileType = "vmDocs";
export const multiCVType = "CV";
export const vatCertificationType = "vatCertification";
export const invoiceType = "invoice";
export const profileLogoType = "profileLogo";
export const deliverablesType = "deliverables";
export const agreementType = "Agreement";
export const agreement30DaysType = "Agreement30Days";
export const NDAType = "NDA";

export const handledUserFileTypes = [
  resumeType,
  sampleOfWorkType,
  certificationType,
  rateCardType,
  portfolioType,
  vmFileType,
  multiCVType,
  vatCertificationType,
  invoiceType,
  profileLogoType,
  deliverablesType,
  agreementType,
  agreement30DaysType,
  NDAType,
];

export const availableDaysOptions = [
  "Sun",
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
];
export const availableDaysOptionsFullDays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
export const availableDaysOptionsMapper = {
  Sat: 6,
  Sun: 7,
  Mon: 1,
  Tue: 2,
  Wed: 3,
  Thu: 4,
  Fri: 5,
};
export const availableDaysOptionsMapperFullDays = {
  Saturday: 6,
  Sunday: 7,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
};

export const availableDaysNumberMapper = {
  6: "Sat",
  7: "Sun",
  1: "Mon",
  2: "Tue",
  3: "Wed",
  4: "Thu",
  5: "Fri",
};
export const availableDaysNumberMapperFullDays = {
  6: "Saturday",
  7: "Sunday",
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
};

export const LANGUAGE_MODEL_NONE = "NONE";
export const LANGUAGE_MODEL_PAIR = "PAIR";
export const LANGUAGE_MODEL_SINGLE = "SINGLE";

export const allowedResumeFileTypes = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const FORMAT_DATE = "DD/MM/YYYY";

export const STATUS_REGISTERED = "registered";
export const STATUS_REJECTED = "rejected";
export const STATUS_SUSPENDED = "suspended";
export const STATUS_INREVIEW = "inreview";
export const STATUS_ACTIVE = "active";
export const STATUS_BLACKLIST = "blacklist";
export const STATUS_QUALIFIED = "qualified";

export const SUBSTATUS_INCOMPLETE = "incomplete";
export const SUBSTATUS_PARTIAL = "partial";
export const SUBSTATUS_COMPLETE = "complete";
export const SUBSTATUS_APPROVED = "approved";
export const SUBSTATUS_WAITING_FOR_OFFICIAL_NDA = "waitingForOfficialNda";
export const SUBSTATUS_UNDER_TESTING = "underTesting";
export const SUBSTATUS_DECLINED_OFFICIAL_NDA = "declinedOfficialNda";
export const SUBSTATUS_EXPIRED_OFFICIAL_NDA = "expiredOfficialNda";
export const SUBSTATUS_PASSED_TEST = "passedTest";
export const SUBSTATUS_FAILED_TEST = "failedTest";
export const SUBSTATUS_ONBOARDING_REQUEST = "onBoardingRequested";
export const SUBSTATUS_ONBOARDING_DONE = "onBoardingDone";
export const SUBSTATUS_READY_FOR_WORK = "readyForWork";
export const SUBSTATUS_DO_NOT_USE = "doNotUse";
export const SUBSTATUS_PENDING_INVESTIGATION = "pendingInvestigation";
export const SUBSTATUS_AGREEMENT_SENT = "agreementSent";
export const SUBSTATUS_DECLINED_AGREEMENT = "declinedAgreement";
export const SUBSTATUS_EXPIRED_AGREEMENT = "expiredAgreement";
export const SUBSTATUS_UNDER_VALIDATION = "underValidation";

export const VM_PORTAL_COOKIE_NAME = "AllowedCookie-t-vm-portal";
export const TARJAMA_PRIVACY_POLICY_LINK =
  "https://tarjama.com/privacy-policy/";

/** TVM-880: When false, vendor-facing preferred currency UI is hidden (USD-only payouts). */
export const SHOW_VENDOR_PREFERRED_CURRENCY_UI = false;

/** Canonical USD currency id for vendor preferred-currency defaults and API payloads. */
export const PREFERRED_CURRENCY_USD_ID =
  "2885c19c-bf27-421e-adbe-59b3b5a36202";

export const domainOtherOption = "Others";

export const catToolsOptions = [
  { label: "memoQ", value: "memoQ" },
  { label: "Phrase", value: "Phrase" },
  { label: "CleverSo", value: "CleverSo" },
];

export const INTERPRETATION_SERVICE_NAME = "Interpretation";
export const DTP_SERVICE_NAME = "Desktop Publishing (DTP)";
export const EDITING_SERVICE_NAME = "Editing";
export const LQE_REVIEW_SERVICE_NAME = "LQE Review";

export const PO_SENT_STATUS = "PO Sent";
export const PO_ACCEPTED_STATUS = "PO Accepted";
export const PO_REJECTED_STATUS = "PO Rejected";
export const REQUEST_PAYMENT_SENT_STATUS = "Request Payment Sent";
export const PO_REQUESTED_STATUS = "Payment Requested";
export const PENDING_FINANCE_APPROVAL = "Pending Finance Approval";
export const PENDING_STAFF_STATUS = "Pending tarjama staff action";

export const colorCodingFileStatusList = [
  {
    color: "bg-red-500",
    status:
      "Assign, Assign T, Assign E, Assign P, Assign Subtitling, Assign CW, Assign CE, PO Rejected",
  },
  {
    color: "bg-blue-500",
    status: "Assign QC, Assign DTP, PO Sent",
  },
  {
    color: "bg-yellow-700",
    status:
      "T in Progress, E in Progress, DTP in Progress, Assigned, In Progress, Request Payment Sent",
  },
  {
    color: "bg-orange-700",
    status: "Payment Requested",
  },
  {
    color: "bg-green-500",
    status: "Completed, PO Accepted",
  },
  {
    color: "bg-purple-400",
    status: "PO Withdrawn",
  },
  {
    color: "bg-pink-400",
    status: "Draft",
  },
  {
    color: "bg-teal-500",
    status: "Pending tarjama staff action",
  },
];

export const DELIVERED_STATUS = "delivered";
export const ONLINE_FULL_DAY_RATE_ID = "db74a069-bef1-4c04-8dff-5bf879343b37";
export const ONLINE_FULL_DAY_TITLE = "online full day";

export const nonMimeTypeFiles = {
  xlm: "application/xlm",
  srt: "text/plain",
};

export const poStatusesOptions = {
  "PO Sent": {
    label: "Invited",
    variant: "orange",
  },

  "PO Accepted": {
    label: "Active",
    variant: "green",
  },

  "PO Rejected": {
    label: "Rejected",
    variant: "red",
  },
  "Pending CS Analysis": {
    label: "CS Review",
    variant: "blue",
  },
};

export const invoicesStatusBadgeOptions = {
  Approved: {
    label: "Approved",
    variant: "green",
  },

  Paid: {
    label: "Paid",
    variant: "green",
  },

  "Pending Approval": {
    label: "Pending Approval",
    variant: "orange",
  },

  Rejected: {
    label: "Rejected",
    variant: "red",
  },
};

export const invoicesStatusOptions = [
  {
    label: "Approved",
    value: "Approved",
  },
  {
    label: "Rejected",
    value: "Rejected",
  },
  {
    label: "Pending Approval",
    value: "Pending Approval",
  },

  {
    label: "Paid",
    value: "Paid",
  },
];

export const INVOICE_STATUS_PENDING_APPROVAL = "Pending Approval";
export const INVOICE_STATUS_REJECTED = "Rejected";
export const DTP_L0_TITLE = "per slide L0";
export const DTP_SERVICE = "dtp";
export const categoryMapForInterpretation = {
  "online full day": "online",
  "online half a day": "online",
  online: "online",
  "overtime online": "online",

  "on site full day": "onSite",
  "on site half a day": "onSite",
  "on site": "onSite",
  "overtime on site": "onSite",
};

export const orderMapForInterpretation = {
  "online full day": 1,
  "online half a day": 2,
  online: 3,
  "overtime online": 4,
  "on site full day": 5,
  "on site half a day": 6,
  "on site": 7,
  "overtime on site": 8,
};

export const poRejectedDurationTimeMin = process.env.REACT_APP_PO_REJECTED_DURATION_TIME_MIN || '15';